/**
 * Component for AccountMessage
 *
 * @module components/AccountMessage
 */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import ButtonT3 from '../../../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../../../components/lib/ButtonT3/constants';
import QA from '../../../../constants/QATags';
import MiniHeader from '../../MiniHeader/MiniHeader';

import '../AccountMessage/AccountMessageBar.scss';

class SubscriptionMessage extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    message: PropTypes.object,
    buttonText: PropTypes.node,
    buttonLink: PropTypes.func,
  };

  renderButton() {
    if (!(this.props.buttonText || this.props.buttonLink)) {
      return;
    }

    return (
      <ButtonT3
        size={ButtonT3Size.SMALL}
        theme={ButtonT3Theme.WHITE}
        href={this.props.buttonLink}
        onClick={this.props.onClose}
      >
        {this.props.buttonText}
      </ButtonT3>
    );
  }

  render() {
    return (
      <MiniHeader showing={true} onClose={this.props.onClose}>
        <div className='AccountMessageBar' data-qa={QA.MB}>
          {this.props.message}
          {this.renderButton()}
        </div>
      </MiniHeader>
    );
  }
}

export default connect(null, null)(SubscriptionMessage);
